import React, { Component } from "react";
import {DatePicker, Checkbox, Radio,Space, Modal } from "antd";
import moment from "moment-timezone";
import { map } from 'lodash';
import * as yup from 'yup';
import CurrencyFormat from 'react-currency-format';
class BatchUpdateSelectedCustomers extends Component {
  state = {
    loader: false,
    is_btn_Active: false,
    errors: {},
    role: "",
    isincreasePriceByPercentage: true,
    isincreasePriceByDollar: false,
    newPercentage: "",
    newDollar: "",
    effective_date: moment().format("YYYY-MM-DD"),
    increase_in_addon: true,
    params: {},
    round_up: false,
    round_down: false,
    apply_visible: false,
    confirm_visible: false,
    display_validation_amount_message: false,
    display_validation_amount_value_message: false,
  };



  closeAndClear = () => {    
    this.props.BatchUpdateToggle(false);
    this.setState({
      effective_date: moment().format("YYYY-MM-DD"),
    });
  };

  setTimePeriod = (e) => {
    if (e) {
      this.setState({
        effective_date: moment(e).format("YYYY-MM-DD"),
      });
    }
  };

  onChangeincreaseinaddon = (e) => {
    this.setState({
      increase_in_addon: e.target.value,
    });
  };
  onChangePriceIncreaseType = (e) =>{
    if(e.target.value !== undefined){
        if(e.target.value === "percentage")
          this.setState({
            isincreasePriceByDollar: false,
            isincreasePriceByPercentage: true,
            newDollar: "",
          });
        else if(e.target.value === "amount")
          this.setState({
            isincreasePriceByDollar: true,
            isincreasePriceByPercentage: false,
            newPercentage: "",
          });
        else{
          this.setState({
            isincreasePriceByDollar: false,
            isincreasePriceByPercentage: false,
            newPercentage: "",
            newDollar: "",
          });
        }
    }else{
      this.setState({
        isincreasePriceByDollar: false,
        isincreasePriceByPercentage: false,
        newPercentage: "",
        newDollar: "",
      });
    }
    
  };
  validatePricing = () => {
    //e.preventDefault();
    let params = {
      price_by_percentage: this.state.isincreasePriceByPercentage,
      amount: this.state.isincreasePriceByPercentage
        ? this.state.newPercentage
        : this.state.newDollar,
      effective_date: this.state.effective_date,
      service_order_ids: this.props.selectedRowKeysUpdate,
    }
    this.setState({
      errors: {},
      params: params
    })

    let self = this;
    setTimeout(() => {
      const schema = yup.object().shape({
        amount: yup.string().required("Please enter a valid integer.")
      })

      // check validity
      let IsValid;
      let err_data = {};
      schema.isValid(params)
        .then(function (valid) {
          IsValid = valid
        });
      //effective_date: moment().add(30, 'days').format("YYYY-MM-DD"),
      setTimeout(() => {
        if (IsValid) {
          self.props.postCustomerPriceIncreaseReport(params)
          self.setState({
            isincreasePriceByPercentage: true,
            isincreasePriceByDollar: false,
            newPercentage: "",
            newDollar: "",
            increase_in_addon: true,
            errors: {},
            round_up: false,
            round_down: false
          });
          //self.closeAndClear();
        }
        else {
          schema.validate(params, { abortEarly: false })
            .catch(function (err) {
              map(err.inner, (item) => {
                err_data[item.path] = item.message;

              })
              self.setState({
                errors: err_data,
              })
            });
        }
      }, 100);
    }, 300);
  };
  disabledDate(current) {
    return current && current < moment().startOf("day");
  };


  load_validation = (type)=>{
  
    if(type === "percentage"){
      if(this.state.display_validation_amount_message && this.state.isincreasePriceByDollar)
        return <span style={{fontSize: 'small'}} className="required">Please add amount value!</span>
      if(this.state.display_validation_amount_value_message && this.state.isincreasePriceByDollar && this.state.newDollar > 100)
        return <span style={{fontSize: 'small'}} className="required">Value should be less than $100</span>
    }if (type === ("amount")){
      if(this.state.display_validation_amount_message && this.state.isincreasePriceByPercentage)
        return <span style={{fontSize: 'small'}} className="required">Please add percentage value!</span>
      if(this.state.display_validation_amount_value_message && this.state.isincreasePriceByPercentage && this.state.newPercentage > 99)
        return <span style={{fontSize: 'small'}} className="required">Value should be less than 99%</span>
    }
    return null;
  }
  
  render() {
    let { loader, errors } = this.state;
    return (
      <div className="group_wrapper rdrawer h-100">
        <div className="card-row flex-column flex-fill">
          <div className="card-full">
            <h4>
              Price Increase For Customers
            </h4>
            <div className="fitem">
              <div className="fitem text_with_place">
                    <Space direction="horizontal">
                    <label className="d-block fs-13 color-22222A lh-18">
                      <b>Number of Customers</b>
                    </label>
                    <input 
                        disabled={true}
                        value={this.props.selected_customers_count}
                        className="form-control flex-1 "
                        inputMode="numeric"
                        style={{ width: '61%', float: 'right', background: "#f4f7f9", border: "1px solid #f4f7f9"}}
                    />
                    </Space>
              </div>
            </div>
            <div className="fitem">
              <div className="fitem text_with_place">
                  <Radio.Group className="swhite" value={this.state.isincreasePriceByPercentage?"percentage":"amount"}onChange={this.onChangePriceIncreaseType}>
                    <Space direction="horizontal">
                      <Radio value={"percentage"} style={{textTransform: 'none'}}>Increase Price by a %</Radio> 
                      <CurrencyFormat 
                        style={{ width: '68%', float: 'right'}}
                        value={this.state.newPercentage}
                        thousandSeparator={true} 
                        disabled={!this.state.isincreasePriceByPercentage}
                        suffix={'%'}
                        decimalSeparator={"."}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        placeholder={"%"}
                        onBlur={(e) => { 
                          if(e?.currentTarget == null || e?.currentTarget?.value===""){
                            this.setState({
                              newPercentage: "",
                            });
                          }                      
                        }}
                        onValueChange={(e) => { 
                            if(e?.floatValue === null || e?.value === '')
                              this.setState({
                                newPercentage: "",
                              });
                            else
                              this.setState({
                                newPercentage: e.floatValue,
                              });
                      }}/>
                      {/* <input
                        style={{ width: '68%', float: 'right'}}
                        type="text"
                        value={this.state.newPercentage}
                        onChange={(e) =>
                          this.setState({
                            newPercentage: e.target.value
                          })
                        }
                        placeholder="%"
                        className="form-control flex-1 "
                        inputMode="numeric"
                        disabled={!this.state.isincreasePriceByPercentage}
                        onPaste={(event) => {
                          if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                            event.preventDefault();
                          }
                        }}
                        onKeyPress={(e) => {
                          const pattern = /[0-9]/;
                          const inputChar = String.fromCharCode(e.charCode);
                          if (!pattern.test(inputChar)) {
                            // invalid character, prevent input
                            e.preventDefault();
                          }
                        }}
                      />                       */}
                    </Space>
                    {this.load_validation("amount")}  
                    <Space direction="horizontal">
                      <Radio value={"amount"} style={{textTransform: 'none'}}>Increase Price by Set $ Amount</Radio>
                      <CurrencyFormat 
                      style={{ width: '79%', float: 'right'}}
                      value={this.state.newDollar}
                      thousandSeparator={true} 
                      disabled={!this.state.isincreasePriceByDollar}
                      prefix={'$'}
                      decimalSeparator={"."}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      placeholder={"$"}
                      onBlur={(e) => { 
                        if(e?.currentTarget == null || e?.currentTarget?.value===""){
                          this.setState({
                            newDollar: "",
                          });
                        }             
                      }}
                      onValueChange={(e) => { 
                          if(e?.floatValue === null || e?.value === '')
                              this.setState({
                                newDollar: "",
                              });
                            else
                              this.setState({
                                newDollar: e.floatValue,
                              });
                    }}/>
                      {/* <input
                        style={{ width: '79%', float: 'right'}}
                        type="text"
                        value={this.state.newDollar}
                        onChange={(e) =>
                          this.setState({
                            newDollar: e.target.value,
                          })
                        }
                        disabled={!this.state.isincreasePriceByDollar}
                        placeholder="$"
                        className="form-control flex-1"
                        inputMode="numeric"
                        onPaste={(event) => {
                          if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                            event.preventDefault();
                          }
                        }}
                        onKeyPress={(e) => {
                          const pattern = /[0-9]/;
                          const inputChar = String.fromCharCode(e.charCode);
                          if (!pattern.test(inputChar)) {
                          // invalid character, prevent input
                            e.preventDefault();
                          }
                        }}
                      /> */}
                    </Space>
                    {this.load_validation("percentage")}                     
                  </Radio.Group>
              </div>
            <div className="fitem mb-16">
              <label className="d-block fs-13 color-22222A lh-18">
                <b>To take affect from:</b>
                {/*<span className="d-block">This must be at least 30 day in to the future</span>*/}
              </label>
              <DatePicker
                format="MM-DD-YYYY"
                suffixIcon={<i className="las la-angle-down"></i>}
                disabledDate={this.disabledDate}
                value={moment(this.state.effective_date)}
                onChange={(e) => {
                  this.setTimePeriod(e);
                }}
              />
            </div>
          </div>
            {/*
            <h4>
              Batch Increase Price for {this.props.selectedRowKeysUpdate.length} Customer
            </h4>
            */}
            {/*
            <div className="fitem">
              <div className="chck-blocks">
                <div className={this.state.isincreasePriceByPercentage ? 'gray_box teal_box' : ''}>
                  <div className="card-body">
                    <Checkbox className="fs-13 txt-none"
                      checked={this.state.isincreasePriceByPercentage}
                      onChange={(e) =>
                        this.setState({
                          isincreasePriceByPercentage: e.target.checked,
                          isincreasePriceByDollar: e.target.checked
                            ? false
                            : "",
                        })
                      }
                    >
                        Increase Price by a %
                    </Checkbox>
                    {this.state.isincreasePriceByPercentage ? (
                      <React.Fragment>
                        <div className="pl-25 pt-11">
                          <div className="form-group">
                            <label className="field-lbl">
                              <b>Percentage Increase</b>
                            </label>
                            <div className="fitem fitem-rinner">
                              {this.state.newPercentage ? <div data-value={this.state.newPercentage}>

                                <input
                                  type="text"
                                  value={this.state.newPercentage}
                                  onChange={(e) =>
                                    this.setState({
                                      newPercentage: e.target.value
                                    })
                                  }
                                  placeholder="Enter New Price in Percentage"
                                  className="form-control flex-1 "
                                  inputMode="numeric"

                                  onPaste={(event) => {
                                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onKeyPress={(e) => {
                                    const pattern = /[0-9]/;
                                    const inputChar = String.fromCharCode(e.charCode);
                                    if (!pattern.test(inputChar)) {
                                      // invalid character, prevent input
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                
                              </div> :
                                <div>
                                  <input
                                    type="text"
                                    value={this.state.newPercentage}
                                    onChange={(e) =>
                                      this.setState({
                                        newPercentage: e.target.value
                                      })
                                    }
                                    placeholder="Enter New Price in Percentage"
                                    className="form-control flex-1 "
                                    inputMode="numeric"

                                    onPaste={(event) => {
                                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onKeyPress={(e) => {
                                      const pattern = /[0-9]/;
                                      const inputChar = String.fromCharCode(e.charCode);
                                      if (!pattern.test(inputChar)) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </div> }
                              {errors['amount'] && this.state.isincreasePriceByPercentage ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['amount']}</label> : ''}
                            </div>
                          </div>
                          <Checkbox className="fs-13 mb-10"
                            disabled={this.state.round_down}
                            onChange={(e) => {
                              this.setState({
                                round_up: e.target.checked
                              })
                            }}
                          >
                          Round up to the nearest $.10
                          </Checkbox>                      
                          <Checkbox className="fs-13 mb-10 ml-0"
                            disabled={this.state.round_up}
                            onChange={(e) => {
                              this.setState({
                                round_down: e.target.checked
                              })
                            }}
                          >
                          Round down to the nearest $.10
                          </Checkbox>
                        </div>
                      </React.Fragment>
                    ) : null}
                    
                  </div>
                </div>
              </div>
            
              <div className="chck-blocks">
                <div className={this.state.isincreasePriceByDollar ? 'gray_box teal_box' : ''}>
                  <div className="card-body">
                    <Checkbox className="fs-13"
                      checked={this.state.isincreasePriceByDollar}
                      onChange={(e) =>
                        this.setState({
                          isincreasePriceByDollar: e.target.checked,
                          isincreasePriceByPercentage: e.target.checked
                            ? false
                            : "",
                        })
                        
                      }
                    >
                        Increase Price by set $ Amount
                    </Checkbox>
                    {this.state.isincreasePriceByDollar ? (
                      <div className="pl-25 pt-11">
                        <div className="form-group">
                          <label className="field-lbl">
                            <b>Dollar Increase</b>
                          </label>
                          <div className="fitem fitem-rinner mb-0">
                            
                            <div className={this.state.newDollar ? 'fix_isd_code' : ''}>
                              {this.state.newDollar ? <span>$</span> : ''}
                              <input
                                type="text"
                                value={this.state.newDollar}
                                onChange={(e) =>
                                  this.setState({
                                    newDollar: e.target.value,
                                  })
                                }
                                placeholder="Enter New Price in Percentage"
                                className="form-control flex-1"
                                inputMode="numeric"

                                onPaste={(event) => {
                                  if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                    event.preventDefault();
                                  }
                                }}
                                onKeyPress={(e) => {
                                  const pattern = /[0-9]/;
                                  const inputChar = String.fromCharCode(e.charCode);
                                  if (!pattern.test(inputChar)) {
                                  // invalid character, prevent input
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            {errors['amount'] && this.state.isincreasePriceByDollar ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['amount']}</label> : ''}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>*/}
            </div>
          
            
            {/*
            <div className="fitem">
              <label className="d-block fs-13 color-22222A lh-18 mb-16">
                <b>For residential customers:</b>
                <span  className="d-block">Apply increase to add-ons</span>
              </label>
              <Radio.Group
                name=" residentialcustomers"
                defaultValue={true}
                onChange={this.onChangeincreaseinaddon}
              >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </div>
          </div>
          */}
          {/*
          <div className="card-full flex-0-auto">
            <div className='gray_box yellow_border_box m-0'>
              <div className='card-body'>
                <p className="fs-14 mb-11"><strong>We&apos;ll send these users an email notifying them of their price increase.</strong></p>
                <p className="fs-13 mb-11"><a href="www.docs.google.com/document/"><strong>www.docs.google.com/document/</strong></a></p>
                <p className="fs-13 mb-0">Users affected may contact the call center and these users will have notifications of this applied to their account.</p>
              </div>
            </div>
          </div>
        */}
        </div>

        


        <div className="footer" style={{ 'width': '400px' }}>
          <button
            className="btn btn-brand btn-bdr"
            onClick={() => {
              this.closeAndClear();
            }}
          >
            Cancel
          </button>

          <button
            className="btn btn-warning"
            onClick={(e) => {
              if((this.state.newPercentage === ""|| this.state.newPercentage === null || this.state.newPercentage === 0) &&(this.state.newDollar === "" || this.state.newDollar === null || this.state.newDollar === 0))
              {
                this.setState({ display_validation_amount_message: true , display_validation_amount_value_message: false});
              }else if(this.state.newPercentage > 99 || this.state.newDollar > 100){
                this.setState({ display_validation_amount_message: false, display_validation_amount_value_message: true });
              }
              else{
                this.setState({ apply_visible: true , display_validation_amount_message: false , display_validation_amount_value_message: false});
              }
            }}
          >
            Apply Changes
          </button>
        </div>
        {loader ? (
          <div className="loader_wrapper">
            <div className="loader07"></div>
          </div>
        ) : (
          ""
        )}
        <Modal 
            title="Apply Price Increase For Customers"
            visible={this.state.apply_visible}
            onCancel={() => { this.setState({ apply_visible: false}) }}
            className="delete_user_modal"
            width={400}
            footer={[
              <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.setState({ apply_visible: false })}>No</button>,
              <button key="apply" className={`btn btn-waning`} onClick={() => {
                this.setState({confirm_visible: true});
                this.validatePricing();
                this.props.resetSelectedRowKeysUpdate();
                }
              }>Yes</button>,
            ]}
        >
            <div>
              <p>Are you sure you would like to apply this price increase for customers?</p>
              <table style={{width: '100%', border: '1px solid #f0f0f0', marginBottom: '10px'}}>                
                <tr className="pi_table_row_border">
                  <td>Number of Customers</td>
                  <td>{this.props.selected_customers_count}</td>
                </tr>
                <tr className="pi_table_row_border">
                  <td>Increase Price</td>
                  {this.state.isincreasePriceByPercentage? <td>{this.state.newPercentage}%</td>
                                               : <td>${this.state.newDollar}</td>           
                  }
                </tr>
                <tr className="pi_table_row_border">
                  <td>Take Affect From</td>
                  <td>{moment(this.state.effective_date).format("MM/DD/YYYY")}</td>
                </tr>
              </table>
            </div>
        </Modal>
        <Modal
            
            title="Price Increase Applied successfully"
            visible={this.state.confirm_visible}
            onCancel={() => { this.setState({apply_visible: false , confirm_visible: false}) }}
            className="delete_user_modal"
            width={400}
            footer={[
              <button key="close" className={`btn btn-waning`} onClick={() =>{
                 this.setState({ apply_visible: false , confirm_visible: false});
                 this.closeAndClear();
                }
                }>Close</button>,
            ]}
        >
            <div style={{height: '135px'}}>
              <p>Your price increase has been saved and will take in affect starting {moment(this.state.effective_date).format("MM/DD/YYYY")}</p>
            </div>
        </Modal>
      </div>
    );
  }
}

export default BatchUpdateSelectedCustomers;
